import { render } from "./GenresSongs.vue?vue&type=template&id=21b3905a&scoped=true"
import script from "./GenresSongs.vue?vue&type=script&lang=js"
export * from "./GenresSongs.vue?vue&type=script&lang=js"

import "./GenresSongs.vue?vue&type=style&index=0&id=21b3905a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b3905a"]])

export default __exports__